// src/i18n/es/common.js
const common = {
    actions: {
        save: 'Guardar',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        edit: 'Editar',
        create: 'Crear',
        search: 'Buscar',
        filter: 'Filtrar',
        export: 'Exportar',
        refresh: 'Actualizar',
    },
    status: {
        active: 'Activo',
        inactive: 'Inactivo',
        pending: 'Pendiente',
        completed: 'Completado',
        cancelled: 'Cancelado',
    },
    messages: {
        loading: 'Cargando...',
        saving: 'Guardando...',
        error: 'Ha ocurrido un error',
        success: 'Operación exitosa',
        confirm_delete: '¿Está seguro de que desea eliminar?',
        no_data: 'No hay datos disponibles',
    },
    notifications: {
        // Session messages
        session_extended_success: 'Sesión extendida con éxito',
        session_extended_with_time: 'Sesión extendida con éxito. Nueva expiración: %{time}',
        session_expired: 'Tu sesión ha expirado. Por favor, vuelve a iniciar sesión.',
        session_will_expire: 'Tu sesión expirará pronto. Por favor, guarda tu trabajo y vuelve a iniciar sesión.',
        session_extend_error: 'Error al extender la sesión. Por favor, guarda tu trabajo.',
        connection_error: 'Error de conexión. Por favor, verifica tu conexión a internet.',
        
        // General errors and success
        load_error: 'Error al cargar los datos',
        save_success: 'Datos guardados con éxito',
        save_error: 'Error al guardar los datos',
        update_success: 'Datos actualizados con éxito',
        update_error: 'Error al actualizar los datos',
        delete_success: 'Elemento eliminado con éxito',
        delete_error: 'Error al eliminar el elemento',
        
        // Validation messages
        field_required: 'Este campo es obligatorio',
        invalid_format: 'Formato inválido',
        duplicate_key: 'Esta clave ya existe',
        permission_denied: 'No tienes permisos para realizar esta acción',
        
        // File operations
        file_select_required: 'Por favor selecciona un archivo',
        file_size_exceeded: 'El archivo no debe superar los 2MB',
        
        // Connection and testing
        connection_success: 'Conexión exitosa',
        connection_failed: 'No se pudo conectar',
        test_connection_error: 'Error al probar la conexión',
        
        // Copy operations
        copied_to_clipboard: 'Copiado al portapapeles',
    },
    warnings: {
        delete_irreversible: 'Esta acción no se puede deshacer',
    },
    filters: {
        label: 'Filtros',
        show: 'Mostrar filtros',
        hide: 'Ocultar filtros',
    },
    help: {
        tooltip: 'Ayuda',
        keyFeatures: 'Funcionalidades principales',
        quickTips: 'Consejos rápidos',
    },
    hotel: 'Hotel',
    not_assigned: 'No asignado',
    back: 'Volver',
    impersonation: {
        action: 'Suplantar identidad',
        pill: 'Suplantando a %{name}',
        exit: 'Salir',
    },
};

export default common;
